module.exports = __webpack_public_path__ + "static/img/address_empty@2x.4eede8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/address_empty@2x.png
// module id = Jh6e
// module chunks = 1